import { SET_NEXT_PIECE, SET_INNER_PIECE, SET_CONDITION_PIECE, SET_LOOP_VARIABLE, SET_ITERABLE_VARIABLE, SET_OPERAND, SET_LEFT_OPERAND, SET_RIGHT_OPERAND, SET_QUESTION_DATA, SET_MEMBER_VARIABLE, SET_DATA_STORE_VALUE, SET_DATA_SET_VALUE, SET_DATA_COPY_VARIABLE, SET_RETURN_VALUE, SET_CONDITION_NEXT_PIECE, SET_CONDITION_PIECE_POSITION, START_PIECE_DRAG, STOP_PIECE_DRAG, SET_TARGET_PIECE, IfData, SET_UPDATE_STATUS_VALUE, SET_UPDATE_DUE_DATE_VALUE, SET_CUSTOM_FIELD, SET_VARIABLE_FOR_SET, UPDATE_VARIABLE_PIECE, PieceType, ADD_PIECE, ADD_FULL_PIECE, SET_CONDITION_PIECES, SET_SELECTED_OPTIONS, NestingData, SET_VARIABLE_FOR_SHOW, SET_ENTITY_TYPE, SET_CUSTOM_FIELDS_FOR_SHOW, DELETE_PIECE, SET_WORKFLOW, SET_WORKFLOW_TYPE, SET_WORKFLOW_STATUS, SET_WORKFLOW_DUE_DATE, SET_WORKFLOW_AFFILIATION_VARIABLE, SET_WORKFLOW_IS_ASYNC, SET_TRANSFER_ROLES, UPDATE_CUSTOM_FIELD_PIECE, SET_VARIABLE_FOR_CUSTOM_FIELD, SET_ERROR, UPDATE_ANSWER_PIECE, UPDATE_STATUS_PIECE, AllPieceTypes, SET_QUESTION_REQUIRED_PIECE, SET_QUESTION_DISABLED_PIECE, SET_QUESTION_DEFAULT_PIECE, SET_VARIABLE_FOR_ADD_MEMBER, SET_VARIABLE_FOR_ADD_GROUP, SET_LOCATION_PIECE, SET_VARIABLE_FOR_LIST, SET_PIECE_FOR_LIST, SET_QUESTION_CHOICE_VARIABLE, SET_MEMBERS_TYPE_IN_GROUP, SET_VARIABLE_PIECE, SET_HEADING, SET_COLUMNS, SET_STRUCTURE_PROJECT, SET_STRUCTURE_LEVEL, SET_STRUCTURE_ROLE, SET_VARIABLE_FOR_ADD_WORKFLOW, SET_YEAR, SET_MONTH, SET_DATE, SET_VARIABLE_FOR_NEW_DATE, SetNextPieceAction, SetInnerPieceAction, SetConditionPiecesAction, SetConditionPieceAction, SetConditionPiecePositionAction, SetConditionNextPieceAction, SetLoopVariable, SetIterableVariable, SetVariableForList, SetPieceForList, SetUpdateStatusValue, SetUpdateDueDateValue, SetOperand, SetSelectedOptions, SetLeftOperand, SetRightOperand, SetQuestionData, SetQuestionChoiceVariable, SetQuestionRequiredPiece, SetQuestionDefaultPiece, SetQuestionDisabledPiece, SetMemberVariable, SetDataStoreValue, SetDataSetValue, SetVariableForSet, SetDataCopyVariable, SetReturnVariable, SetError, SetCustomField, SetVariableForShow, SetEntityType, SetCustomFieldsForShow, SetVariableForCustomField, IStartDragAction, IStopDragAction, ISetTargetPieceAction, IDeletePieceAction, IUpdateVariablePieceAction, IUpdateCustomFieldPieceAction, IUpdateAnswerPieceAction, IUpdateStatusPieceAction, ISetWorkflowAction, ISetWorkflowTypeAction, ISetWorkflowStatusAction, ISetWorkflowDueDateAction, ISetWorkflowAffiliationVariableAction, SetVariableForAddGroup, SetVariableForAddMember, SetVariableForAddWorkflow, SetLocationPiece, ISetWorkflowIsAsyncAction, ISetTransferRolesAction, AddPieceAction, AddFullPieceAction, ISetMemberTypeToGroupAction, SetVariablePieceAction, SetFormatModifierAction, ISetHeadingAction, ISetColumnsAction, ISetYearAction, SetVariableForDate, ISetMonthAction, ISetDateAction, ISetStructureProjectAction, ISetStructureLevelAction, ISetStructureRoleAction, SetMessageAction, SET_MESSAGE, SET_REPORT_NAME, SET_REPORT_TYPE, SET_REPORT_USER, SET_REPORT_START_DATE, SET_REPORT_END_DATE, SET_VARIABLE_FOR_ADD_REPORT, ISetReportNameAction, ISetReportTypeAction, ISetReportUserAction, ISetReportStartDateAction, ISetReportEndDateAction, SetVariableForAddReport, SetQuestionImage, SET_QUESTION_IMAGE, SetRichTextForShow, SET_RICH_TEXT_FOR_SHOW, SET_FORMAT_MODIFIER, SET_TIME_DIFFERENCE_FORMAT, SetTimeDifferenceFormatAction, ICopyPieceAction, COPY_PIECE, SHOW_RICH_TEXT_EDITOR, IShowRichTextEditorAction, IHideRichTextEditorAction, HIDE_RICH_TEXT_EDITOR, SET_VARIABLE_FOR_CURRENT_LOCATION, SetVariableForCurrentLocation, ISetStaticDataHolderAction, SET_STATIC_DATA_HOLDER, ISetDataFragmentsAction, SET_DATA_FRAGMENTS, SET_STARTING_DISPLAY_FOR_SHOW, SetStartingDisplayForShow, SetXAxisForShow, SET_X_AXIS_FOR_SHOW, SetYAxisForShow, SET_Y_AXIS_FOR_SHOW, SetYAxisAggregationForShow, SET_Y_AXIS_AGGREGATION_FOR_SHOW, SetWidgetTitleForShow, SET_WIDGET_TITLE_FOR_SHOW, ISetWorkflowShowErrorsAction, SET_WORKFLOW_SHOW_ERRORS, ADD_FULL_PIECES, AddFullPiecesAction, SetEntity, SET_ENTITY } from './types';
import moment from 'moment';

export function setNextPiece(pieceId: string, value: string|undefined): SetNextPieceAction {
    return {
        type: SET_NEXT_PIECE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setInnerPiece(pieceId: string, value: string|undefined): SetInnerPieceAction {
    return {
        type: SET_INNER_PIECE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setConditionPieces(pieceId: string, value: Array<IfData>): SetConditionPiecesAction {
    return {
        type: SET_CONDITION_PIECES,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setConditionForIfPiece(pieceId: string, ifIndex: number, value: string|undefined): SetConditionPieceAction {
    return {
        type: SET_CONDITION_PIECE,
        pieceId,
        ifIndex,
        value,
        updateTime: moment().format(),
    }
}

export function setConditionPiece(pieceId: string, value: string|undefined): SetConditionPieceAction {
    return {
        type: SET_CONDITION_PIECE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setConditionPosition(pieceId: string, ifIndex: number, x: number, y: number): SetConditionPiecePositionAction {
    return {
        type: SET_CONDITION_PIECE_POSITION,
        pieceId,
        ifIndex,
        x,
        y,
        updateTime: moment().format(),
    }
}

export function setConditionNextPiece(pieceId: string, ifIndex: number, value: string|undefined): SetConditionNextPieceAction {
    return {
        type: SET_CONDITION_NEXT_PIECE,
        pieceId,
        ifIndex,
        value,
        updateTime: moment().format(),
    }
}

export function setLoopVariable(pieceId: string, value: string|undefined): SetLoopVariable {
    return {
        type: SET_LOOP_VARIABLE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setIterableVariable(pieceId: string, value: string|undefined): SetIterableVariable {
    return {
        type: SET_ITERABLE_VARIABLE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setVariableForList(pieceId: string, variable: string|undefined): SetVariableForList {
    return {
        type: SET_VARIABLE_FOR_LIST,
        pieceId,
        variable,
        updateTime: moment().format(),
    }
}

export function setPieceForList(pieceId: string, dataToSet: string|undefined): SetPieceForList {
    return {
        type: SET_PIECE_FOR_LIST,
        pieceId,
        dataToSet,
        updateTime: moment().format(),
    }
}

export function setUpdateStatusValue(pieceId: string, value: string|undefined): SetUpdateStatusValue {
    return {
        type: SET_UPDATE_STATUS_VALUE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setUpdateDueDateValue(pieceId: string, value: string|undefined): SetUpdateDueDateValue {
    return {
        type: SET_UPDATE_DUE_DATE_VALUE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setOperand(pieceId: string, value: string|undefined): SetOperand {
    return {
        type: SET_OPERAND,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setSelectedOptions(pieceId: string, value: Array<string>): SetSelectedOptions {
    return {
        type: SET_SELECTED_OPTIONS,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setLeftOperand(pieceId: string, value: string|undefined): SetLeftOperand {
    return {
        type: SET_LEFT_OPERAND,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setRightOperand(pieceId: string, value: string|undefined): SetRightOperand {
    return {
        type: SET_RIGHT_OPERAND,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setQuestionData(pieceId: string, value: string|undefined): SetQuestionData {
    return {
        type: SET_QUESTION_DATA,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setQuestionChoiceVariable(pieceId: string, value: string|undefined): SetQuestionChoiceVariable {
    return {
        type: SET_QUESTION_CHOICE_VARIABLE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setQuestionRequiredPiece(pieceId: string, value: string|undefined): SetQuestionRequiredPiece {
    return {
        type: SET_QUESTION_REQUIRED_PIECE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setQuestionDefaultPiece(pieceId: string, value: string|undefined): SetQuestionDefaultPiece {
    return {
        type: SET_QUESTION_DEFAULT_PIECE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setQuestionImage(pieceId: string, value: string|undefined): SetQuestionImage {
    return {
        type: SET_QUESTION_IMAGE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setQuestionDisabledPiece(pieceId: string, value: string|undefined): SetQuestionDisabledPiece {
    return {
        type: SET_QUESTION_DISABLED_PIECE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setMemberVariable(pieceId: string, value: string|undefined): SetMemberVariable {
    return {
        type: SET_MEMBER_VARIABLE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setDataStoreValue(pieceId: string, value: string|undefined): SetDataStoreValue {
    return {
        type: SET_DATA_STORE_VALUE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setDataSetValue(pieceId: string, value: string|undefined): SetDataSetValue {
    return {
        type: SET_DATA_SET_VALUE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setVariableForSet(pieceId: string, value: string|undefined): SetVariableForSet {
    return {
        type: SET_VARIABLE_FOR_SET,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setVariableForCurrentLocation(pieceId: string, value: string|undefined): SetVariableForCurrentLocation {
    return {
        type: SET_VARIABLE_FOR_CURRENT_LOCATION,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setDataCopyVariable(pieceId: string, value: string|undefined): SetDataCopyVariable {
    return {
        type: SET_DATA_COPY_VARIABLE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setReturnValue(pieceId: string, value: string|undefined): SetReturnVariable {
    return {
        type: SET_RETURN_VALUE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setError(pieceId: string, error: string|undefined): SetError {
    return {
        type: SET_ERROR,
        pieceId,
        error,
        updateTime: moment().format(),
    }
}

export function setCustomField(pieceId: string, value: string|undefined): SetCustomField {
    return {
        type: SET_CUSTOM_FIELD,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setVariableForShow(pieceId: string, value: string|undefined): SetVariableForShow {
    return {
        type: SET_VARIABLE_FOR_SHOW,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setStartingDisplayForShow(pieceId: string, value: 'table'|'line'|'bar'|'donut'): SetStartingDisplayForShow {
    return {
        type: SET_STARTING_DISPLAY_FOR_SHOW,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setWidgetTitleForShow(pieceId: string, value: string|undefined): SetWidgetTitleForShow {
    return {
        type: SET_WIDGET_TITLE_FOR_SHOW,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setXAxisForShow(pieceId: string, value: string): SetXAxisForShow {
    return {
        type: SET_X_AXIS_FOR_SHOW,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setYAxisForShow(pieceId: string, value: string|undefined): SetYAxisForShow {
    return {
        type: SET_Y_AXIS_FOR_SHOW,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setYAxisAggregationForShow(pieceId: string, value: 'sum'|'average'|undefined): SetYAxisAggregationForShow {
    return {
        type: SET_Y_AXIS_AGGREGATION_FOR_SHOW,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setRichTextForShow(pieceId: string, value: boolean|undefined): SetRichTextForShow {
    return {
        type: SET_RICH_TEXT_FOR_SHOW,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setEntity(pieceId: string, value: 'LOCATION'|'USER'|'MEMBER'|'GROUP'|'WORKFLOW'|undefined): SetEntity {
    return {
        type: SET_ENTITY,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setEntityType(pieceId: string, value: string|undefined): SetEntityType {
    return {
        type: SET_ENTITY_TYPE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setCustomFieldsForShow(pieceId: string, value: Array<string>): SetCustomFieldsForShow {
    return {
        type: SET_CUSTOM_FIELDS_FOR_SHOW,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setVariableForCustomField(pieceId: string, value: string|undefined): SetVariableForCustomField {
    return {
        type: SET_VARIABLE_FOR_CUSTOM_FIELD,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function startPieceDrag(pieceId: string): IStartDragAction {
    return {
        type: START_PIECE_DRAG,
        pieceId,
    };
}

export function stopPieceDrag(): IStopDragAction {
    return {
        type: STOP_PIECE_DRAG,
    };
}

export function setTargetPiece(pieceId: string|undefined): ISetTargetPieceAction {
    return {
        type: SET_TARGET_PIECE,
        pieceId,
    };
}

export function deletePiece(pieceId: string): IDeletePieceAction {
    return {
        type: DELETE_PIECE,
        pieceId,
        updateTime: moment().format(),
    }
}

export function copyPiece(pieceId: string): ICopyPieceAction {
    return {
        type: COPY_PIECE,
        pieceId,
        updateTime: moment().format(),
    }
}

export function showRichTextEditor(): IShowRichTextEditorAction {
    return {
        type: SHOW_RICH_TEXT_EDITOR,
    }
}

export function hideRichTextEditor(): IHideRichTextEditorAction {
    return {
        type: HIDE_RICH_TEXT_EDITOR,
    }
}

export function updateVariablePiece(pieceId: string, variable: string|undefined, nesting: Array<NestingData>|undefined): IUpdateVariablePieceAction {
    return {
        type: UPDATE_VARIABLE_PIECE,
        pieceId,
        variable,
        nesting,
        updateTime: moment().format(),
    }
}

export function updateCustomFieldPiece(pieceId: string, customField: string|undefined, customFieldOption: string|undefined): IUpdateCustomFieldPieceAction {
    return {
        type: UPDATE_CUSTOM_FIELD_PIECE,
        pieceId,
        customField,
        customFieldOption,
        updateTime: moment().format(),
    }
}

export function updateGroupedAnswerPiece(pieceId: string, customField: string|undefined): IUpdateAnswerPieceAction {
    return {
        type: UPDATE_ANSWER_PIECE,
        pieceId,
        customField,
        updateTime: moment().format(),
    }
}

export function updateStatusPiece(pieceId: string, statusId: string|undefined): IUpdateStatusPieceAction {
    return {
        type: UPDATE_STATUS_PIECE,
        pieceId,
        statusId,
        updateTime: moment().format(),
    }
}

export function setWorkflow(pieceId: string, workflow: string): ISetWorkflowAction {
    return {
        type: SET_WORKFLOW,
        pieceId,
        workflow,
        updateTime: moment().format(),
    }
}

export function setWorkflowType(pieceId: string, workflowType: string): ISetWorkflowTypeAction {
    return {
        type: SET_WORKFLOW_TYPE,
        pieceId,
        workflowType,
        updateTime: moment().format(),
    }
}

export function setWorkflowStatus(pieceId: string, status: string): ISetWorkflowStatusAction {
    return {
        type: SET_WORKFLOW_STATUS,
        pieceId,
        status,
        updateTime: moment().format(),
    }
}

export function setWorkflowDueDate(pieceId: string, dueDate: string): ISetWorkflowDueDateAction {
    return {
        type: SET_WORKFLOW_DUE_DATE,
        pieceId,
        dueDate,
        updateTime: moment().format(),
    }
}

export function setWorkflowShowErrors(pieceId: string, shouldShowErrors: boolean): ISetWorkflowShowErrorsAction {
    return {
        type: SET_WORKFLOW_SHOW_ERRORS,
        pieceId,
        shouldShowErrors,
        updateTime: moment().format(),
    }
}

export function setWorkflowAffiliationVariable(pieceId: string, affiliationVariable: string|undefined): ISetWorkflowAffiliationVariableAction {
    return {
        type: SET_WORKFLOW_AFFILIATION_VARIABLE,
        pieceId,
        affiliationVariable,
        updateTime: moment().format(),
    }
}

export function setReportName(pieceId: string, name: string|undefined): ISetReportNameAction {
    return {
        type: SET_REPORT_NAME,
        pieceId,
        name,
        updateTime: moment().format(),
    }
}

export function setReportType(pieceId: string, reportType: string|undefined): ISetReportTypeAction {
    return {
        type: SET_REPORT_TYPE,
        pieceId,
        reportType,
        updateTime: moment().format(),
    }
}

export function setReportUser(pieceId: string, user: string|undefined): ISetReportUserAction {
    return {
        type: SET_REPORT_USER,
        pieceId,
        user,
        updateTime: moment().format(),
    }
}

export function setReportStartDate(pieceId: string, startDate: string|undefined): ISetReportStartDateAction {
    return {
        type: SET_REPORT_START_DATE,
        pieceId,
        startDate,
        updateTime: moment().format(),
    }
}

export function setReportEndDate(pieceId: string, endDate: string|undefined): ISetReportEndDateAction {
    return {
        type: SET_REPORT_END_DATE,
        pieceId,
        endDate,
        updateTime: moment().format(),
    }
}

export function setVariableForAddMember(pieceId: string, variable: string): SetVariableForAddMember {
    return {
        type: SET_VARIABLE_FOR_ADD_MEMBER,
        pieceId,
        variable,
        updateTime: moment().format(),
    }
}

export function setVariableForAddGroup(pieceId: string, variable: string): SetVariableForAddGroup {
    return {
        type: SET_VARIABLE_FOR_ADD_GROUP,
        pieceId,
        variable,
        updateTime: moment().format(),
    }
}

export function setVariableForAddWorkflow(pieceId: string, variable: string): SetVariableForAddWorkflow {
    return {
        type: SET_VARIABLE_FOR_ADD_WORKFLOW,
        pieceId,
        variable,
        updateTime: moment().format(),
    }
}

export function setVariableForAddReport(pieceId: string, variable: string): SetVariableForAddReport {
    return {
        type: SET_VARIABLE_FOR_ADD_REPORT,
        pieceId,
        variable,
        updateTime: moment().format(),
    }
}

export function setLocationPiece(pieceId: string, location: string|undefined): SetLocationPiece {
    return {
        type: SET_LOCATION_PIECE,
        pieceId,
        location,
        updateTime: moment().format(),
    }
}

export function setStartWorkflowIsAsync(pieceId: string, isAsync: boolean): ISetWorkflowIsAsyncAction {
    return {
        type: SET_WORKFLOW_IS_ASYNC,
        pieceId,
        isAsync,
        updateTime: moment().format(),
    }
}

export function setTransferRoles(pieceId: string, roles: Array<string>): ISetTransferRolesAction {
    return {
        type: SET_TRANSFER_ROLES,
        pieceId,
        roles,
        updateTime: moment().format(),
    }
}

export function addPiece(pieceId: string, pieceType: PieceType): AddPieceAction {
    return {
        type: ADD_PIECE,
        pieceId,
        pieceType,
        createdTime: moment().format(),
    }
}

export function addFullPiece(pieceData: AllPieceTypes): AddFullPieceAction {
    return {
        type: ADD_FULL_PIECE,
        pieceData: {
            ...pieceData,
            createdTime: moment().format(),
            lastUpdatedTime: moment().format(),
        },
    }
}

export function addFullPieces(piecesData: Array<AllPieceTypes>): AddFullPiecesAction {
    const now = moment().format();

    return {
        type: ADD_FULL_PIECES,
        piecesData: piecesData.map(pieceData => {
            return {
                ...pieceData,
                createdTime: now,
                lastUpdatedTime: now,
            };
        }),
    }
}

export function setMemberTypeToGroup(pieceId: string, value: 'representatives'|'all_members'): ISetMemberTypeToGroupAction {
    return {
        type: SET_MEMBERS_TYPE_IN_GROUP,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setVariablePiece(pieceId: string, variablePiece: string|undefined): SetVariablePieceAction {
    return {
        type: SET_VARIABLE_PIECE,
        pieceId,
        variablePiece,
        updateTime: moment().format(),
    }
}

export function setFormatModifier(pieceId: string, formatModifier: string|undefined): SetFormatModifierAction {
    return {
        type: SET_FORMAT_MODIFIER,
        pieceId,
        formatModifier,
        updateTime: moment().format(),
    }
}

export function setTimeDifferenceFormat(pieceId: string, format: string|undefined): SetTimeDifferenceFormatAction {
    return {
        type: SET_TIME_DIFFERENCE_FORMAT,
        pieceId,
        format,
        updateTime: moment().format(),
    }
}

export function setHeading(pieceId: string, value: string|undefined): ISetHeadingAction {
    return {
        type: SET_HEADING,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setColumns(pieceId: string, value: string|undefined): ISetColumnsAction {
    return {
        type: SET_COLUMNS,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setVariableForDate(pieceId: string, value: string|undefined): SetVariableForDate {
    return {
        type: SET_VARIABLE_FOR_NEW_DATE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setYear(pieceId: string, value: string|undefined): ISetYearAction {
    return {
        type: SET_YEAR,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setMonth(pieceId: string, value: string|undefined): ISetMonthAction {
    return {
        type: SET_MONTH,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setDate(pieceId: string, value: string|undefined): ISetDateAction {
    return {
        type: SET_DATE,
        pieceId,
        value,
        updateTime: moment().format(),
    }
}

export function setStructureProject(pieceId: string, project: string|undefined): ISetStructureProjectAction {
    return {
        type: SET_STRUCTURE_PROJECT,
        pieceId,
        project,
        updateTime: moment().format(),
    }
}

export function setStructureLevel(pieceId: string, level: string|undefined): ISetStructureLevelAction {
    return {
        type: SET_STRUCTURE_LEVEL,
        pieceId,
        level,
        updateTime: moment().format(),
    }
}

export function setStructureRole(pieceId: string, role: string|undefined): ISetStructureRoleAction {
    return {
        type: SET_STRUCTURE_ROLE,
        pieceId,
        role,
        updateTime: moment().format(),
    }
}

export function setStaticDataHolder(pieceId: string, staticData: string|undefined): ISetStaticDataHolderAction {
    return {
        type: SET_STATIC_DATA_HOLDER,
        pieceId,
        staticData,
        updateTime: moment().format(),
    }
}

export function setDataFragments(pieceId: string, dataFragments: Array<string>|undefined): ISetDataFragmentsAction {
    return {
        type: SET_DATA_FRAGMENTS,
        pieceId,
        dataFragments,
        updateTime: moment().format(),
    }
}

export function setMessage(pieceId: string, message: string|undefined): SetMessageAction {
    return {
        type: SET_MESSAGE,
        pieceId,
        message,
        updateTime: moment().format(),
    }
}